/**
 * Returns a formatted string which is lowercase and all spaces replaced with underscores
 *
 * e.g.
 *  convertToUnderscore('Main Buntons') //=> "main_buntons"
 *  convertToUnderscore('a VEry strAnge_ string') //=> "a_very_strange__string"
 *
 * @param {string} string The string to convert
 */

export function convertToUnderscore (string) {
  return string.toLowerCase().split(' ').join('_');
}
